import QueryString from "query-string";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useMeCore } from "../../../../cores/me";
import { useRouterCore } from "../../../../cores/router";
import { useWooCommerceCore } from "../../../../cores/wooCommerce";
import { LoadingSpinnerWembii } from "../../LoadingSpinnerWembii";

export default function WooCommercePopUp() {
  const { search } = useLocation();
  const { bind, name, url } = useWooCommerceCore();
  const { company, getMeSocialSettings } = useMeCore();
  const { goToSocial } = useRouterCore();

  useEffect(() => {
    let cancelled = false;

    const completeOAuth = async () => {
      const { success } = QueryString.parse(search);
      const isSuccess = Array.isArray(success)
        ? success.includes("1")
        : success === "1";

      if (isSuccess && company?.id && url && name) {
        await bind(company.id, url, name, () => {
          getMeSocialSettings(company.id);
        });
      }

      if (!cancelled) {
        goToSocial();
      }
    };

    completeOAuth();

    return () => {
      cancelled = true;
    };
  }, [search, company, bind, goToSocial, url, name, getMeSocialSettings]);

  return <LoadingSpinnerWembii active />;
}
